<template>
  <div>
    <div class="sl-color-picker">
      <span class="mr-8" v-if="label">{{ label }}:</span>
      <div
        class="sl-color-picker__preview"
        :style="{ background: value }"
      ></div>
      <div class="sl-color-picker__value">{{ value }}</div>
      <ui-button
        class="sl-color-picker__btn"
        shadow
        color="light"
        text-color="dark"
        @click="open"
        >{{ $t("message.common.change") }}</ui-button
      >
    </div>
    <ui-dialog
      :show="isOpen"
      :title="$t('message.storeLocator.basic.selectPrimaryColor').toString()"
      max-width="352"
      @input="close"
    >
      <v-color-picker
        v-model="pickerValue"
        hide-mode-switch
        mode="hexa"
      ></v-color-picker>

      <template #actions>
        <ui-button outlined @click="close">{{
          $t("message.common.cancel")
        }}</ui-button>
        <ui-button @click="save">{{ $t("message.common.save") }}</ui-button>
      </template>
    </ui-dialog>
  </div>
</template>

<script>
export default {
  name: "StoreLocatorConfigColorPicker",
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: {
      type: String,
      required: true
    },
    label: {
      type: [String, Object]
    }
  },
  data: () => ({
    isOpen: false,
    pickerValue: null
  }),
  created() {},
  methods: {
    open() {
      this.pickerValue = this.value;
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    },
    save() {
      this.$emit("change", this.pickerValue);
      this.close();
    }
  }
};
</script>

<style lang="scss" scoped>
.sl-color-picker {
  display: flex;
  align-items: center;
  @include font-size(14px);
  color: $dark-blue-3;

  &__preview {
    width: 48px;
    height: 48px;
    border-radius: 100%;
    margin-right: $spacing * 1.5;
    box-shadow: inset 0 0 1px $light-3;
  }

  &__value {
    margin-right: $spacing * 7.5;
  }

  &__btn {
    width: 130px;
  }
}
</style>
